"use client";

import Image from "next/image";
import { Button } from "@/components/ui/button";

interface Cta14Props {
  title?: string;
  text?: string;
  ctaText?: string;
  ctaHref?: string;
  backgroundImage?: string;
  backgroundColor?: string;
  titleColor?: string;
  textColor?: string;
  buttonBackgroundColor?: string;
  buttonTextColor?: string;
  overlay?: boolean;
}

const Cta14 = ({
  title = "Vende tu propiedad con Person",
  text = "Seguridad, rapidez y acompañamiento para una venta más eficaz y cómoda. ¡Vende tu propiedad con la tranquilidad de estar en buenas manos! Empieza conociendo el valor de tu inmueble.",
  ctaText = "Contacta con nosotros",
  ctaHref = "#",
  backgroundImage,
  backgroundColor,
  titleColor,
  textColor,
  buttonBackgroundColor,
  buttonTextColor,
  overlay = true,
}: Cta14Props) => {
  const handleCtaClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Check if href is a hash link (starts with #)
    if (ctaHref?.startsWith("#") && ctaHref.length > 1) {
      e.preventDefault();
      const targetId = ctaHref.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
    // If it's just "#" or not a hash link, let default behavior happen
  };
  return (
    <section className="relative">
      <div 
        className="flex min-h-[400px] md:h-[620px] items-center justify-center overflow-hidden relative py-16 md:py-0"
        style={backgroundColor ? { backgroundColor } : undefined}
      >
        {/* Background Image with Next.js Image optimization */}
        {backgroundImage && (
          <Image
            src={backgroundImage}
            alt="CTA Background"
            fill
            quality={75}
            sizes="100vw"
            className="object-cover"
            loading="lazy"
            fetchPriority="low"
            referrerPolicy="no-referrer-when-downgrade"
          />
        )}
        {/* Dark overlay - only show if background image exists and overlay is true */}
        {backgroundImage && overlay && (
          <div className="absolute left-0 top-0 h-full w-full bg-black/65 z-10" />
        )}
        
        {/* Content */}
        <div className="flex flex-col gap-6 md:gap-4 p-4 sm:p-6 md:p-4 text-center items-center relative z-20 max-w-2xl mx-auto">
          <h2 
            className="text-2xl sm:text-3xl md:text-3xl px-4"
            style={titleColor ? { color: titleColor } : undefined}
          >
            {title}
          </h2>
          <p 
            className="text-base leading-relaxed max-w-xl px-4"
            style={textColor ? { color: textColor } : undefined}
          >
            {text}
          </p>
          <div className="flex flex-col justify-center gap-2 mt-3 sm:flex-row">
            <Button 
              asChild
              size="lg" 
              className="hover:opacity-90 transition-opacity"
              style={{ 
                backgroundColor: buttonBackgroundColor || '#193144',
                color: buttonTextColor || 'white'
              }}
            >
              <a 
                href={ctaHref} 
                onClick={handleCtaClick}
                target={ctaHref && !ctaHref.startsWith('#') ? '_blank' : undefined}
                rel={ctaHref && !ctaHref.startsWith('#') ? 'noopener noreferrer' : undefined}
              >
                {ctaText}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export { Cta14 };

